var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[(_vm.url)?_c('div',[_c('iframe',{attrs:{"src":_vm.url,"allowfullscreen":_vm.allowfullscreen,"frameborder":_vm.frameborder,"type":_vm.type}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }